import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CalculationState } from '../calculation.state';
import { CalculationDto, CalculationTypeEnum, CustomShapesMeasurementDto, ShapeDto } from '../../../api/models';
import { loadCalculation, setContact, setIsCompany, setModels } from '../calculation.actions';
import { MeasurementsType, TileMeasurementsType } from '../steps/measurements/measurements.constants';
import { CalculationStepRoutes, roofTypeToRouteMap } from '../calculation.constants';
import { omit } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class LoadCalculationService {
  constructor(private readonly store: Store<CalculationState>, private readonly router: Router) {}

  async loadCalculation(calculation: CalculationDto): Promise<void> {
    const stateCalculation: Partial<CalculationState> = {
      isLoaded: true,
      id: calculation.id,
      accessories: calculation.accessories,
      measurements: omit(calculation.measurements, [
        'groundToEavesHeight',
        'rainSystem',
        'eavesDescents',
      ]) as MeasurementsType,
      annexes: calculation.annexes ?? undefined,
      roofType: calculation.roofType,
      apiCalculation: calculation,
    };
    stateCalculation.accessories = calculation.accessories.map((accessory) => {
      delete accessory.price;
      return accessory;
    });

    if ((calculation.measurements as TileMeasurementsType).rainSystem?.rainSystem) {
      stateCalculation.rainSystem = (calculation.measurements as TileMeasurementsType).rainSystem;
    }

    if (calculation.roofType === CalculationTypeEnum.CustomShape) {
      (stateCalculation.measurements as CustomShapesMeasurementDto).shapes = (
        calculation.measurements as CustomShapesMeasurementDto
      ).shapes.map((shape: ShapeDto) => {
        if (
          shape.points[0].x === shape.points[shape.points.length - 1].x &&
          shape.points[0].y === shape.points[shape.points.length - 1].y
        ) {
          shape.points.pop();
        }
        return shape;
      });
    }
    this.store.dispatch(
      loadCalculation({ payload: stateCalculation as CalculationState, roofType: calculation.roofType }),
    );
    if (calculation.color) {
      this.store.dispatch(
        setModels({
          isLoaded: true,
          models: {
            producer: calculation.color.thickness.finish.product.producer,
            roof: calculation.color.thickness.finish.product,
            finish: calculation.color.thickness?.finish,
            thickness: calculation.color.thickness,
            color: calculation.color,
            hasDripStop: calculation.hasDripStop || false,
          },
        }),
      );
    }
    if (calculation.shoppingCart?.order) {
      this.store.dispatch(setContact({ contact: calculation.shoppingCart.order.contact }));
      this.store.dispatch(
        setIsCompany({ isCompany: !!calculation.shoppingCart.order.contact.company?.representativeFirstName }),
      );
    }
    const roofTypeRoute = roofTypeToRouteMap[calculation.roofType as CalculationTypeEnum];
    if (calculation.roofType === CalculationTypeEnum.Custom && !calculation.color) {
      this.router.navigate([`sistem-pluvial`]);
    } else {
      this.router.navigate([`calcul`, roofTypeRoute, CalculationStepRoutes.MEASUREMENTS]);
    }
  }
}
